export default __webpack_public_path__ + "mg.jpg?ec434f7f8429b03a85e66e5e66f33146";